import { themedStyled } from 'common/styles/styletron.theme';

export const CollapsibleContainer = themedStyled('div', ({ $theme }) => ({
  // padding: '8px 0 8px',
  userSelect: 'none',
  flex: 1,
}));

export const LinkContainer = themedStyled('div', ({ $theme }) => ({
  padding: '8px 0 8px',
  userSelect: 'none',
  flex: 1,
  ':hover': {
    background: $theme.colors.bg1,
  },
}));

export const IconContainer = themedStyled('div', ({ $theme }) => ({
  ':hover': {
    background: $theme.colors.bg1,
  },
  marginLeft: '-18px',
}));
export const IconWrapper = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  padding: '8px 12px 8px 0px',
  cursor: 'pointer',
  marginLeft: '18px',
}));

export const BeforeBorder = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  overflow: 'hidden',
  transition: 'all 300ms',
  msTransition: 'all 300ms',
  MozTransition: 'all 300ms',
  WebkitTransition: 'all 300ms',
}));

export const Column = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  transition: 'all 300ms',
  msTransition: 'all 300ms',
  MozTransition: 'all 300ms',
  WebkitTransition: 'all 300ms',
}));

export const ChevronContainer = themedStyled('div', ({ $theme }) => ({
  width: '24px',
  height: '24px',
  transition: 'all 300ms',
  msTransition: 'all 300ms',
  MozTransition: 'all 300ms',
  WebkitTransition: 'all 300ms',
}));
